import styled from '@emotion/styled'

const StyledDeItems = styled.div`
  width: 100%;
  padding: 2% 10%;
  height: calc(100vh);
`

const StyledDeTitles = styled.div`
  width: 100%;
  font-size: 24px;
  font-weight: 600;
  color: var(--ow-text-color);
  text-align: center;
`
const StyleBox = styled.div`
  width: 100%;
  height: 40px;
  line-height: 40px;
`

const StyledDeCategory = styled.span`
  width: 50%;
  font-weight: 300;
  font-size: 13px;
  text-align: left;
  float: left;
`

const StyledDeTimes = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 200;
  color: var(--ow-text-color);
  text-align: right;
`
const StyledrNumber = styled.div`
  width: 100%;
  font-size: 12px;
  font-weight: 200;
  text-align: center;
`
const StyledDeLabels = styled.div`
  font-size: 13px;
  color: var(--ow-text-color);
  margin: 10px 0px;
`

const StyledDeSummarys = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: var(--ow-text-color);
  line-height: 2;
  margin: 10px 0px;
  text-align: justify;
`

export {
  StyledDeItems,
  StyledDeCategory,
  StyledDeTitles,
  StyleBox,
  StyledDeTimes,
  StyledrNumber,
  StyledDeLabels,
  StyledDeSummarys,
}
